export const getBuyerMaterialSpecificationUrl = (tradeCompanyId: number): string => {
  return `/ground-control/v2/manage-company/${tradeCompanyId}/material-specifications`;
};
